// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dURRU","largestCol":"styles_largestCol__1i1nB","smallestCol":"styles_smallestCol__3ttN-"};